import React from 'react';
import { SignUp } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';

export const SignupPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-terminal-bg flex flex-col items-center justify-center p-4">
      {/* Logo */}
      <div className="mb-8 text-center">
        <Link to="/" className="inline-flex items-center gap-3 group">
          <div className="relative">
            <div className="h-10 w-10 bg-gradient-to-br from-cyan-400 to-emerald-400 rounded flex items-center justify-center text-black font-black text-sm shadow-lg shadow-cyan-500/20">
              7S
            </div>
            <div className="absolute -top-0.5 -right-0.5 h-2 w-2 bg-emerald-400 rounded-full animate-pulse" />
          </div>
          <div>
            <span className="text-terminal-bright font-bold tracking-tight text-2xl">
              ALPHA<span className="text-cyan-400">OPTIONS</span>
            </span>
          </div>
        </Link>
        <p className="text-terminal-dim mt-2">Create your account to get started</p>
      </div>

      {/* Clerk Sign Up Component */}
      <div className="w-full max-w-md">
        <SignUp
          appearance={{
            elements: {
              rootBox: 'w-full',
              card: 'bg-terminal-card border border-terminal-border shadow-2xl rounded-xl',
              headerTitle: 'text-white font-bold',
              headerSubtitle: 'text-terminal-dim',
              socialButtonsBlockButton: 'bg-slate-800 border-terminal-border text-white hover:bg-slate-700',
              socialButtonsBlockButtonText: 'text-white font-medium',
              dividerLine: 'bg-terminal-border',
              dividerText: 'text-terminal-dim',
              formFieldLabel: 'text-terminal-dim',
              formFieldInput: 'bg-slate-900 border-terminal-border text-white focus:border-cyan-500 focus:ring-cyan-500',
              formButtonPrimary: 'bg-gradient-to-r from-cyan-500 to-emerald-500 hover:from-cyan-400 hover:to-emerald-400 text-black font-bold',
              footerActionLink: 'text-cyan-400 hover:text-cyan-300',
              identityPreviewText: 'text-white',
              identityPreviewEditButton: 'text-cyan-400',
              formFieldInputShowPasswordButton: 'text-terminal-dim hover:text-white',
              alert: 'bg-rose-500/10 border-rose-500/30 text-rose-400',
              alertText: 'text-rose-400',
            },
            variables: {
              colorPrimary: '#22d3ee',
              colorBackground: '#1a1f2e',
              colorText: '#e2e8f0',
              colorTextSecondary: '#94a3b8',
              colorInputBackground: '#0f172a',
              colorInputText: '#e2e8f0',
              borderRadius: '0.75rem',
            }
          }}
          fallbackRedirectUrl="/dashboard"
          signInUrl="/login"
        />
      </div>

      {/* Features Preview */}
      <div className="mt-8 grid grid-cols-3 gap-4 max-w-md text-center">
        <div className="p-3 bg-terminal-card/50 rounded-lg border border-terminal-border/50">
          <div className="text-cyan-400 font-bold text-lg">7-Step</div>
          <div className="text-terminal-dim text-sm">Framework</div>
        </div>
        <div className="p-3 bg-terminal-card/50 rounded-lg border border-terminal-border/50">
          <div className="text-emerald-400 font-bold text-lg">Real-time</div>
          <div className="text-terminal-dim text-sm">Data</div>
        </div>
        <div className="p-3 bg-terminal-card/50 rounded-lg border border-terminal-border/50">
          <div className="text-amber-400 font-bold text-lg">Pro</div>
          <div className="text-terminal-dim text-sm">Analysis</div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 text-center text-terminal-dim text-sm">
        <p>Already have an account? <Link to="/login" className="text-cyan-400 hover:text-cyan-300">Sign in</Link></p>
        <p className="mt-4">
          <Link to="/pricing" className="text-terminal-dim hover:text-white">View Pricing</Link>
          <span className="mx-2">•</span>
          <Link to="/" className="text-terminal-dim hover:text-white">Back to Home</Link>
        </p>
      </div>
    </div>
  );
};

export default SignupPage;
